import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '14px',
    '& > button': {
      marginTop: 2,
    },
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#002E47',
  },
  description: {
    marginTop: 4,
    fontSize: '14px',
    color: '#637381',
  },
})

/** Switch + "Certification" title and description, shared by both states. */
const CertificationHeader = ({ toggle }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {toggle}
      <div>
        <div className={classes.title}>Certification</div>
        <div className={classes.description}>
          Award learners a digital certificate when they complete this path or
          pass the success threshold.
        </div>
      </div>
    </div>
  )
}

export default CertificationHeader
